import { useState, useEffect } from 'react';
import axios from 'axios';
import AdminBackButton from '../components/AdminBackButton';

const API_URL = '/backend/api/';

function AdminScoring() {
  const [round, setRound] = useState(1);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}get_answers_for_scoring.php?round=${round}`);
      if (res.data.success) {
        setData(res.data);
      }
    } catch (err) {
      alert('Fout bij ophalen antwoorden');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [round]);

  // Optimistic update: direct UI update, save in background
  const scoreAnswer = async (teamId, roundNumber, questionIndex, score) => {
    // Update local state immediately
    setData(prevData => {
      if (!prevData) return prevData;
      const newData = { ...prevData };
      const team = newData.teams.find(t => t.team_id === teamId);
      if (team && team.answers[questionIndex]) {
        team.answers[questionIndex].score = score;
      }
      return newData;
    });

    // Save to backend (fire and forget)
    axios.post(`${API_URL}score_answer.php`, {
      team_id: teamId,
      round_id: roundNumber,
      question: questionIndex + 1,
      score: score
    }).catch(() => {
      alert('Fout bij opslaan — refresh om te synchroniseren');
    });
  };

  const getColor = (score) => {
    if (score === "1" || score === "1.0") return 'bg-green-400';
    if (score === "0.5") return 'bg-yellow-400';
    if (score === "0" || score === "0.0") return 'bg-red-400';
    return 'bg-gray-200';
  };

  if (loading) return <div className="p-8 text-center">Laden...</div>;
  if (!data) return <div className="p-8 text-center">Geen data</div>;

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-4xl font-bold text-center mb-8">Nakijken - Ronde {data.round}</h1>
<AdminBackButton />
        <div className="mb-8 text-center">
          <label className="text-xl mr-4">Ronde:</label>
          <select value={round} onChange={(e) => setRound(parseInt(e.target.value))} className="px-4 py-2 border rounded text-xl">
            {Array.from({ length: 11 }, (_, i) => i + 1).map(r => (
              <option key={r} value={r}>Ronde {r}</option>
            ))}
          </select>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full bg-white shadow-lg rounded-lg">
            <thead className="bg-gray-800 text-white">
              <tr>
                <th className="p-4 text-left">Team</th>
                {Array.from({ length: data.questions_per_round || 8 }, (_, i) => (
                  <th key={i} className="p-4">Vraag {i + 1}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.teams.map(team => (
                <tr key={team.team_name} className="border-b">
                  <td className="p-4 font-bold">{team.team_name}</td>
                  {Array.from({ length: data.questions_per_round || 8 }, (_, i) => {
                    const ans = team.answers[i] || { text: '', score: null };
                    return (
                      <td key={i} className="p-2 text-center">
                        <div className={`p-1 rounded mb-2 ${getColor(ans.score)}`}>
                          {ans.text.trim() || '(leeg)'}
                        </div>
                        <div className="flex justify-center gap-2">
                          <button onClick={() => scoreAnswer(team.team_id, round, i, "1.0")} className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm">Goed</button>
                          <button onClick={() => scoreAnswer(team.team_id, round, i, "0.5")} className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded text-sm">Half</button>
                          <button onClick={() => scoreAnswer(team.team_id, round, i, "0.0")} className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-sm">Fout</button>
                        </div>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        

        <div className="mt-12 text-center">
          <button onClick={fetchData} className="bg-gray-600 text-white px-6 py-3 rounded-lg">
            Handmatig vernieuwen
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdminScoring;